import Vue from 'vue'
import Vuex from 'vuex'

// Store For Template Theme
import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

// app Store
import auth from './storeModules/auth'

/**
 * Admin Store
 */
import companies from './storeModules/company'
import companiesGroups from './storeModules/companiesGroup'
import scheduledEmails from './storeModules/scheduledEmail'
import emailTemplates from './storeModules/emailTemplate'

Vue.use(Vuex)

export default new Vuex.Store({

    // Template Theme Store
    getters,
    mutations,
    state,
    actions,
    strict: process.env.NODE_ENV !== 'production',

    modules: {
      auth,
      companies,
      companiesGroups,
      emailTemplates,
      scheduledEmails
    },
})
